import type { AppOpenModal } from "@shared/models/analytics/app"
import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import { partial } from "lodash-es"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import type { Narrative } from "@shared/actions/create-narrative"
import createNarrative from "@shared/actions/create-narrative"

interface Payload {
  modalName: string
  /** Extra properties for the event, so a modal's opens can be told apart in analytics. */
  context?: Record<string, unknown>
}

export default function openModalAction(payload: Payload): PreparedAction {
  return {
    name: "OPEN_MODAL",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: AppOpenModal = {
    ...createBlankEvent(),
    root_id: null,
    root_type: "app",

    primary_verb: "use",
    primary_possessive: "owns",

    primary_object_type: "app",
    primary_object_id: "commoncurriculum.com",
    primary_object_specifier: null,
    primary_object_id_and_ancestor_ids: ["commoncurriculum.com"],

    adverbial_verb: "opening",

    adverbial_object_type: "modal",
    adverbial_object_id: payload.modalName,
    adverbial_object_specifier: null,
    // We can't put the modalName here because it's not a FixedString(24).
    adverbial_object_id_and_ancestor_ids: null,
  }
  return createNarrative({
    title: "Opened a modal",
    description: `User opened the modal "${payload.modalName}"`,
    titleForAnalytics: "Modal - Open",
    context: {
      ...payload.context,
      modalName: payload.modalName,
    },
    newAnalyticsEvents: [newEvent],
  })
}
